<template>
    <footer class="footer d-flex align-items-center">
        <div class="container">
            <div class="d-flex flex-column flex-md-row justify-content-between align-items-center">
                <div class="d-flex flex-column flex-sm-row align-items-center">
                    <img :src="G.systemData?.logo?.value" style="width: 40px;" class="me-41">
                    <p class="ms-1 mb-1 small" v-html="TR?.footer_copyright"></p>
                    <p class="ms-4 mb-1 small" v-html="G.footerPowered"></p>
                </div>
                <div class="d-flex gap-4 mb-1 small">
                </div>
                <!-- <div class="d-flex gap-4 mb-1 small"> -->
                <ul class="footer-menu d-flex gap-4 mb-1 small align-items-sm-center list-inline">
                    <MenuItem v-for="item in data" :key="item.id" :data="item" />
                </ul>
                    <!-- <a href="#">Site Map</a> -->
                <!-- </div> -->
                <!-- <div class="social-icons d-flex gap-2">
                    <a href="#"><i class="fab fa-facebook fs-6"></i></a>
                    <a href="#"><i class="fas fa-envelope fs-6"></i></a>
                    <a href="#"><i class="fab fa-instagram fs-6"></i></a>
                    <a href="#"><i class="fas fa-rss fs-6"></i></a>
                </div> -->
                <div class="social-icons" v-if="socials.length">
                    <template v-for="(item, index) in socials" :key="index">
                        <a v-if="item.icon" :href="item.link || '#'" target="_blank"><i :class="item.icon"></i></a>
                        <a v-else :href="item.link || '#'" target="_blank"><img :src="item.image" style="width: 20px; height: 20px;"></img></a>
                    </template>
                </div>
            </div>
        </div>
    </footer>
</template>


<script>
import MenuItem from '@/components/navbar/MenuItem';

import { G } from '@/_common';

export default {
    name: 'Footer2C',
    components: {
        MenuItem,
    },
    props:{
        data:{
            type: Array,
            default: () => []
        },
        socials:{
            type: Array,
            default: () => []
        },
        TR:{
            type: Object,
            default: () => {}
        },
    },
    setup() {
        return { G };
    },
}
</script>


<style lang="scss">
.footer {
    // background-color: rgb(var(--site-primary-color-rgb));
    // background: linear-gradient(to top, transparent, rgba(200, 200, 200, 0.5));
    background: linear-gradient(to bottom, transparent, rgba(var(--site-primary-color-rgb), 0.3));
    color: rgb(var(--site-primary-color-rgb));
    padding: 2rem 0;
    min-height: 80px;
}
.footer-info-link {
    font-size: 8pt;
}
.footer a {
    color: rgb(var(--site-primary-color-rgb));
    text-decoration: none;
}
.footer a:hover {
    color: rgb(var(--site-primary-color-rgb));
}
.social-icons {
    display: grid;
    // gap: .5rem;
    grid-template-columns: repeat(13, 0fr);
    // align-content: center;
    // text-align: center;
}
.social-icons > a {
    display: inline-flex;
    align-items: center;
    margin: 4px;
    // padding: 2px;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    font-size: 12pt;
    justify-content: center;
    align-items: center;
    // background-color: #443f3f;
    // color: white;
}
.social-icons > a:hover, .footer-menu > li > a:hover {
    background-color: rgba(var(--site-primary-color-rgb), .8) !important;
    color: #ffffff;
    // background-color: #9ba5c4 !important;
}

@media(max-width: 576px){
    // .footer{
    //     // height: 120px;
    // }
    .social-icons {
        grid-template-columns: repeat(9, 0fr);
    }
}
</style>